<template>
  <div class="container" style="background-color: #fff;">
    <HeaderComponent :menu-id="3"></HeaderComponent>
    <div class="title-ty" style="position: relative; padding-bottom: 50px;">
      <img class="xiaci-border" style="bottom: -50px; height: 100px;" src="@/assets/image/border-bj-2.png" alt="">
      <div class="title-ty-y">SHUISHI GRADING</div>
      <div class="title-ty-z"><span>机制币送评</span>评级标准</div>
    </div>
    <div style="background-color: #FFFAF4;">
        <ul class="biaozhun-list jizhibi-biaozhun-list">
          <li class="biaozhun-item" style="width: 460px; font-size: 24px; line-height: 58px;">水石评级采用70分制品相评级体系</li>
          <li class="biaozhun-item biaozhun-item-text" style="width: 700px;">按照送评钱币的磨损程度、铸造精度、原光保留、包浆状态、瑕疵缺陷等进
行评级打分。</li>
        </ul>
        <div class="title-s-ty" style="margin: 80px auto 40px; ">分数段位分类</div>
        <ul class="biaozhun-list" style="width: 1200px; margin: 0 auto; padding: 0;">
          <li class="biaozhun-item" style="background-color: #fff;" v-for="item in duanWeiList">
            <div class="biaozhun-item-title">{{ item.title }}</div>
            <div class="biaozhun-item-text">{{ item.tag }}</div>
            <div class="biaozhun-item-fen">{{ item.fen }}</div>
            <div class="biaozhun-item-text">{{ item.text }}</div>
          </li>
        </ul>
        
    </div>
    <div style="position: relative; padding: 100px 0;">
      <img class="xiaci-border" style="position: absolute;top: 0; left: 0; transform: rotate(180deg); bottom: -50px; height: 100px;" src="@/assets/image/border-bj-2.png" alt="">
      <div class="title-s-ty">细分分值详细标准</div>
      <div class="xifen-box" v-for="item in fenZhiList" >
        <div class="title-b-ty">{{ item.title }}</div>
        <ul class="xifen-list">
          <li class="xifen-item" v-for="(biaoZhun,index) in item.biaoZhunList">({{ index + 1 }}) {{ biaoZhun }}</li>
        </ul>
      </div>
    </div>
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
      duanWeiList: [
        {
          id: 1,
          title: 'MS',
          tag: '未流通/原光',
          fen:'60—70',
          text: '出厂未流通状态，保留原始铸造光泽，无自然流通磨损，依据底板光洁度、细节完整度划分细分分值'
        },
        {
          id: 2,
          title: 'AU',
          tag: '近未使用',
          fen:'50/53/55/58',
          text: '轻微流通磨损，图案高点少量磨耗，币面保留部分原光，整体完整度高'
        },
        {
          id: 3,
          title: 'XF',
          tag: '精美流通品',
          fen:'40/45',
          text: '常规流通好品，主要文字、图案轮廓完整，高点明显磨损，无大面积破损腐蚀'
        },
        {
          id: 4,
          title: 'VF',
          tag: '普通流通品',
          fen:'25/30/35',
          text: '长期流通磨损，局部细节磨损缺失，图案可辨识，无结构性破损'
        },
        {
          id: 5,
          title: '真品无分',
          tag: '真品',
          fen:'无分',
          text: '磨损过重、缺陷较多，达不到VF基础打分标准，入盒标注[真品+瑕疵代码】'
        }
      ],
      fenZhiList: [
        {
          id: 1,
          title: 'MS原光系列',
          biaoZhunList: [
            'MS70:完美出厂品相，底板无任何划痕、磕碰，全细节饱满，满原光，无氧化瑕疵;',
            'MS65一MS69:底板洁净，细微点状痕迹极少，币面85%以上原光，图文深峻完整，高点无磨损;',
            'MS63一MS64:底板少量细微丝痕，局部轻微弱打，70%以上原光，整体细节完整;',
            'MS61一MS62:多处细小划痕、轻微铸造小瑕疵，原光占比50%以上，文字完整;',
            'MS60:币面细小划痕偏多，局部轻微磕碰，仍保留原生光泽，无流通磨耗。'
          ]
        },
        {
          id: 2,
          title: 'AU近未流通系列',
          biaoZhunList: [
            'AU58:仅币面最高点微量磨损，原光留存>70%，版型完整;',
            'AU55:币面局部轻微流通磨损，高点轻微磨损，原光留存>50%;',
            'AU53/AU50:币面轻微流通磨损，高点轻微磨损，底板部分存原光。'
          ]
        },
        {
          id: 3,
          title: 'XF/VF流通系列',
          biaoZhunList: [
            'XF45:图案主体完整，细节大半保留，边道完好，局部磨损;',
            'XF40:细节小幅缺失，整体品相规整;',
            'VF35/30/25:大面积磨损，次要花纹缺失，主文字可辨认，无裂补等硬伤。'
          ]
        }
      ]
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
body{
  overflow-x: hidden;
}
</style>